import React from 'react'
import ComputerSiderLayout from '../ComputerLayouts/ComputerSiderLayout'
import MobileHeaderLayout from '../MobileLayouts/MobileHeaderLayout'
import TabletHeaderLayout from '../TabletLayouts/TabletHeaderLayout'
import { screenSize } from '../../../Common/Common'

export default function SiderLayout () {
  const layouts = {
    Mobile: MobileHeaderLayout,
    Computer: ComputerSiderLayout,
    Tablet: TabletHeaderLayout
  }

  const ResponsiveLayout = layouts[screenSize()]

  return (
    <ResponsiveLayout />
  )
}
